<template>
    <div class="emap-thematic-tools">
        <div class="content">
            <a @click="switchTable">
                <i class="icon-table" title="统计表" />
            </a>
            <div class="separator"></div>
            <a @click="switchChart">
                <i class="icon-chart" title="统计图" />
            </a>
        </div>
    </div>
</template>

<script>
import { eventMgr } from './events';

export default {
    methods: {
        switchTable() {
            eventMgr.fire('switchTableDisplay');
        },
        switchChart() {
            eventMgr.fire('switchChartDisplay');
        },
    },
};
</script>
